module.exports = __webpack_public_path__ + "img/banner-report.29ae1e01.jpg";